import {createMuiTheme} from "@material-ui/core";

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#6A961F",
            light: "#84BA26",
            dark: "#547718"
        },
        secondary: {
            main: "#0D3C00",
            light: "#166600",
            dark: "#092900"
        }
    }
});
